@if (boxes(); as boxes) {
<div class="ui-nutrition-boxes" [ngClass]="design()">
	@if (!isMobileOrTabletView()) {
	<div [libFlexRow]="false" [libFlexRowGap]="'16px'" [libFlexRowAlign]="nutritionRowAlign()">
		@for (box of boxes; track box.title) { @if (design() === 'tags') {
		<div libFlexColumn [libFlexSize]="box.tagType === 'kcal' ? '100px' : '90px'">
			<lib-tag [libTooltip]="box.title" [tagType]="box.tagType">{{ box.value }}</lib-tag>
		</div>
		} @if (design() === 'tagsAlt') {
		<div libFlexColumn [libFlexSize]="'90px'">
			<lib-tag [libTooltip]="box.title" [tagType]="box.tagType">
				<div>
					{{ box.title }}
				</div>
				<div>
					{{ box.value }}
				</div>
				@if (box.percentageOfTotal && showPercentageOfTotal()) {
				<lib-divider class="push-top-xs push-bottom-xs"></lib-divider>
				<div class="ui-percentage-of-total">{{ box.percentageOfTotal }} %</div>
				}
			</lib-tag>
		</div>
		} @else if (design() === 'alt') {
		<div libFlexColumn [libFlexSize]="'90px'">
			<div [ngClass]="box.className" [libTooltip]="box.title">
				<div>
					{{ box.value }}
				</div>
			</div>
		</div>
		} }
	</div>
	} @else if (isMobileOrTabletView()) {
	<div [libFlexRow]="true" [libFlexRowGap]="'16px'">
		@for (box of boxes; track box.title) {

		<div libFlexColumn [style.width]="calculateFlexWidth(2, 16)">
			<lib-tag [libTooltip]="box.title" [tagType]="box.tagType">
				<div>
					{{ box.title }}
				</div>
				<div>
					{{ box.value }}
				</div>
				@if (box.percentageOfTotal && showPercentageOfTotal()) {
				<lib-divider class="push-top-xs push-bottom-xs"></lib-divider>
				<div class="ui-percentage-of-total">{{ box.percentageOfTotal }} %</div>
				}
			</lib-tag>
		</div>

		}
	</div>
	}
</div>
}
